import { create } from "zustand"

const useAlertStore = create((set) => ({
  isOpen: false,
  message: "",
  severity: "info", // can be 'success', 'error', 'warning', or 'info'
  showAlert: (message, severity = "info") => set({ isOpen: true, message, severity }),
  hideAlert: () => set({ isOpen: false }),
}))

export default useAlertStore
